<a
  *ngIf="!hide"
  class="d-flex detail-button"
  (click)="dropdownClick(params.rowIndex, uniqueId)"
  href="#"
  id="atlas-gridgroup-{{ params.rowIndex }}-{{ uniqueId }}"
  role="button"
  data-display="static"
  data-bs-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
>
  <div class="type">
    {{ recipients }}
  </div>
  <wsb-atlas-button
    id="atlas-gridgroup-{{ params.rowIndex }}-{{ uniqueId }}"
    class="mb-2 icon-sms-detail"
    [variant]="'primary'"
    [inlineIcon]="'assets/images/icons/icon-view-detail.svg'"
  ></wsb-atlas-button>
</a>
<div
  class="dropdown dropdown-buttongroup dropdown-menu  dropdown-menu-right"
  id="atlas-gridgroup-m-{{ params.rowIndex }}-{{ uniqueId }}"
  [attr.aria-labelledby]="'atlas-gridgroup-' + params.rowIndex + '-' + uniqueId"
>
  <ng-container>
    <p *ngIf="lowQualitySms" style="width: 145px;" class="mb-0 ms-1 me-1">{{ 'sms_detail_no_data_available' | translate }}.</p>
    <table class="table">
      <tbody *ngIf="!lowQualitySms">
        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_delivered' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.delivered ? params.data.statusCount?.delivered.sms : 0 }}</td>
        </tr>

        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_error' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.error ? params.data.statusCount?.error.sms : 0 }}</td>
        </tr>

        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_waiting' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.waiting ? params.data.statusCount?.waiting.sms : 0 }}</td>
        </tr>

        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_timeout' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.timeout ? params.data.statusCount?.timeout.sms : 0 }}</td>
        </tr>

        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_blocked' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.blocked ? params.data.statusCount?.blocked.sms : 0 }}</td>
        </tr>

        <tr>
          <td class="left-column">
            <span>{{ 'sms_detail_statuscount_blacklisted' | translate }}:</span>
          </td>
          <td class="right-column">{{ params.data?.statusCount?.blacklisted ? params.data.statusCount?.blacklisted.sms : 0 }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
